// extracted by mini-css-extract-plugin
export var option = "_8z-0";
export var optionCard = "_8z-f";
export var optionContent = "_8z-g";
export var optionIcon = "_8z-i";
export var optionIconBox = "_8z-h";
export var optionLabel = "_8z-j";
export var optionPill = "_8z-m";
export var optionPillBadge = "_8z-p";
export var optionPillIcon = "_8z-n";
export var optionPillLabel = "_8z-o";
export var optionRadio = "_8z-k";
export var optionRadioInner = "_8z-l";
export var optionReveal = "_8z-2";
export var optionRevealDelay0 = "_8z-3";
export var optionRevealDelay1 = "_8z-4";
export var optionRevealDelay10 = "_8z-d";
export var optionRevealDelay11 = "_8z-e";
export var optionRevealDelay2 = "_8z-5";
export var optionRevealDelay3 = "_8z-6";
export var optionRevealDelay4 = "_8z-7";
export var optionRevealDelay5 = "_8z-8";
export var optionRevealDelay6 = "_8z-9";
export var optionRevealDelay7 = "_8z-a";
export var optionRevealDelay8 = "_8z-b";
export var optionRevealDelay9 = "_8z-c";
export var optionSelected = "_8z-1";